import { ESocialMedia, ISocialShareButtonList } from 'hooks/socialShare/type';
import { IconImage } from 'petdna-lib-uicomponents/components';
import { buildTemplateForContext } from 'petdna-lib-uicomponents/helpers';
import React from 'react';

interface ISocialSharingButtonsListProps {
  shareUrl: string;
  text?: string;
  socialShareButtonList: ISocialShareButtonList
}

const SocialSharingButtonsList: React.FC<ISocialSharingButtonsListProps> = ({ shareUrl, socialShareButtonList, text = 'Ancestry Pet DNA' }) => {
  const handleClick = (type: ESocialMedia) => {
    const config = socialShareButtonList.shareButtons.find(({ share }) => type === share);
    if (!config) return;

    const encodedText = encodeURIComponent(config?.text?.text || text);
    const encodedShareUrl = encodeURIComponent(shareUrl);

    const url = buildTemplateForContext(
      config.shareEndpoint,
      { url: encodedShareUrl, text: encodedText },
    );

    if (url) {
      window.open(url);
    }
  };

  return (
    <div className="social-share-buttons">
      {socialShareButtonList.shareButtons.map((btn) => (
        <button
          key={btn.id}
          type="button"
          className="btn round-6 share-btn"
          onClick={() => handleClick(btn.share)}
          aria-label={`Share to ${btn.share}`}
        >
          {btn?.icon?.url && (
          <IconImage
            style={{ width: 32, height: 32 }}
            color="#1E4537"
            src={btn.icon.url}
          />
          )}
        </button>
      ))}
    </div>
  );
};

export default SocialSharingButtonsList;
